import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface HeroProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Hero
  location: PageProps['location']
}

interface PostProps {
  [key: string]: any
}

const HeroShell: React.FC<HeroProps> = ({ fields, location }) => {
  const types: PostProps = {
    ribbon: loadable(() => import('components/flex/Hero/Hero')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default HeroShell
